import { Component, OnInit } from '@angular/core';
import { Heurecommande } from '../../models/heurecommande';
import { HeureService } from './heure.service';
import { Subscription } from 'rxjs';
import { NGXLogger } from 'ngx-logger';
import { MatSnackBar, MatDialog, MatDialogRef } from '@angular/material';
import { ConfirmationService } from 'src/app/confirm/confirmation.service';
import { ConfigService } from 'ngx-envconfig';
import { AddheurecmdComponent } from './addheurecmd/addheurecmd.component';
import { Agentstorage } from 'src/app/models/agentstorage';
import { Rolefonction } from 'src/app/models/rolefonction';


import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';


@Component({
  selector: 'fury-heurecmd',
  templateUrl: './heurecmd.component.html',
  styleUrls: ['./heurecmd.component.scss']
})
export class HeurecmdComponent implements OnInit {




  getItemSub: Subscription;
  items: Heurecommande[];
  scrollBarHorizontal = (window.innerWidth < 1200);
  temp = [];
  rows = [];
  columns = [];

//afficher heure commande

  public afficherHeurecommande: boolean;
  public creationHeurecommande: boolean;
  public modificationHeurecommande: boolean;
  public suppressionHeurecommande: boolean;

  public keyAfficherHeurecommande = 'afficher heure commande';
  public keyCreationHeurecommande = 'creation heure commande';
  public keyModificationHeurecommande = 'modification heure commande';
  public keySuppressionHeurecommande = 'suppression heure commande';

  constructor(private logger: NGXLogger, private heureservice: HeureService,
    private snack: MatSnackBar, private confirmService: ConfirmationService,
    private dialog: MatDialog,
    private configService: ConfigService) { }

  ngOnInit() {
    this.verifierDroit();
    this.getallHaurecmd();
  }






  public verifierDroit() {
    this.logger.trace('BEGIN');
    // this.logger.trace('Clé', this.configService.get('keylocalstorage'));

    let agentOnline: Agentstorage;
    agentOnline = JSON.parse(localStorage.getItem(this.configService.get('keylocalstorage')));
    // this.logger.trace(agentOnline);
    let rolefontion: Rolefonction[] = agentOnline.rolefonction;
    // this.logger.trace('rolefontion', rolefontion);

    for (const key in rolefontion) {
      if (rolefontion.hasOwnProperty(key)) {
        // this.logger.trace('KEY', key);
        const element = rolefontion[key].fonction.fonctionname;
        this.logger.trace('element', element);

        if (element == this.keyAfficherHeurecommande) {
          this.logger.trace('true');
          this.afficherHeurecommande = true;
        }
        if (element == this.keyCreationHeurecommande) {
          this.logger.trace('true');
          this.creationHeurecommande = true;
        }
        if (element == this.keyModificationHeurecommande) {
          this.logger.trace('true');
          this.modificationHeurecommande = true;
        }
        if (element == this.keySuppressionHeurecommande) {
          this.logger.trace('true');
          this.suppressionHeurecommande = true;
        }
      }
    }

  }


  updateFilter(event) {
    const val = event.target.value.toLowerCase();
    var columns = Object.keys(this.temp[0]);
    // Removes last "$$index" from "column"
    columns.splice(columns.length - 1);

    // console.log(columns);
    if (!columns.length)
      return;

    const rows = this.temp.filter(function (d) {
      for (let i = 0; i <= columns.length; i++) {
        let column = columns[i];
        // console.log(d[column]);
        if (d[column] && d[column].toString().toLowerCase().indexOf(val) > -1) {
          return true;
        }
      }
    });

    this.items = rows;
  }



  getallHaurecmd() {
    this.getItemSub = this.heureservice.get("heurecommande/getall")
      .subscribe(data => {

        let statuscode = data.status;
        this.logger.trace('DATA', data);

        switch (statuscode) {

          case 200: {
            this.items = data.body;
            this.temp = data.body;
            break;
          }

          case 204: {
            this.snack.open('Aucune Heure disponible', 'OK', { duration: 4000 })
            break;
          }

          default: {
            this.snack.open('Une erreur est survenue!', 'OK', { duration: 4000 })

            break;
          }

        }
      },
        error => {
          this.logger.error("error");
          this.logger.error(error);

          switch (error.status) {

            default: {
              this.snack.open('Une erreur est survenue!', 'OK', { duration: 4000 })

              break;
            }
          }
        });
  }




  openPopUp(data: any = {}, isNew?) {
    let title = isNew ? 'Ajouter une Heure de commande' : 'Mettre à jour une Heure de commande';
    let dialogRef: MatDialogRef<any> = this.dialog.open(AddheurecmdComponent, {
      width: '720px',
      disableClose: true,
      data: { title: title, payload: data }
    })
    dialogRef.beforeClose()
      .subscribe(res => {
        if (!res) {
          // If user press cancel
          return;
        }
        this.getallHaurecmd();

      })
  }


  deleteItem(row) {

    this.confirmService.confirm({ message: `Supprimé ${row.heurecommandelibelle}?` })
      .subscribe(res => {
        if (res) {
          this.heureservice.post(row, "heurecommande/delete")
            .subscribe(data => {
              let statuscode = data.status;
              switch (statuscode) {
                case 200: {
                  // Actualisé les données
                  this.getallHaurecmd();
                  this.snack.open('Heure commande Supprimé!', 'OK', { duration: 4000 })
                  break;
                }
                case 500: {
                  this.snack.open('Internal server error!', 'OK', { duration: 4000 })
                  break;
                }
                default: {
                  this.snack.open('Une erreur est survenue!', 'OK', { duration: 4000 })
                  break;
                }
              }

            },
              error => {
                let statuscode = error.status;
                switch (statuscode) {
                  case 404: {
                    this.snack.open('Not found!', 'OK', { duration: 4000 })
                    break;
                  }
                  case 500: {
                    this.snack.open('Internal server error!', 'OK', { duration: 4000 })
                    break;
                  }
                  default: {
                    this.snack.open('Une erreur est survenue!', 'OK', { duration: 4000 })
                    break;
                  }
                }

              });
        }

      })


  }





  exportToXls() {
    let itemscsv: any[] = [];


    if (this.items.length > 0) {
      this.items.forEach(function (element) {
        console.log(element);


        var my_json = {
          "Libele": element.heurecommandelibelle,
          "Heure debut": element.heurecommandeheuredebut,
          "Heure fin": element.heurecommandeheurefin

        };
        console.log("my_json");
        console.log(my_json);
        itemscsv.push(my_json);
      });
      console.log(itemscsv);

      this.exportAsExcelFile(itemscsv, 'Historique Plat Heure commande');

    }
  }
  public exportAsExcelFile(json: any[], excelFileName: string): void {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }
  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], { type: EXCEL_TYPE });
    FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
  }





}
